module.exports = __webpack_public_path__ + "static/img/dcxt.c930bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dcxt.png
// module id = THPp
// module chunks = 0